<template>
    <div v-if="getPairData" :class="fullType ? 'open-position' : 'open-position open-position-mini'">
      <div class = "open-position__summary"
        :class="fullType ? '' : 'open-position__summary-no-border'">
        <div class = "open-position__summary-number">{{getCount}}</div>
        <div class = "open-position__summary-currency_pair">{{getSymbol}}</div>
        <div class = "open-position__summary-sell-buy" 
          :class = "(volumePositions.sell < volumePositions.buy) ? 'color-green' : 'color-red'">
          <i :class = "(volumePositions.sell < volumePositions.buy) ? 'mdi mdi-arrow-up' : 'mdi mdi-arrow-down'"></i> {{(volumePositions.sell < volumePositions.buy) ? 'buy' : 'sell'}}</div>
        <div class = "open-position__summary-deposit">{{(volumePositions.sell < volumePositions.buy) ? $moneyf(volumePositions.buy) : $moneyf(volumePositions.sell)}}</div>
        <div class = "open-position__summary-rait">{{(volumePositions.sell < volumePositions.buy) ? averagePrice.buy.toFixed(5) : averagePrice.sell.toFixed(5)}}</div>
        <div class="open-position__summary-ico">
            <i :class = "fullType ? icoUp : icoDown" @click="showFull"></i>
        </div>
      </div>
      <div class = "open-position__profit-loss" v-show="fullType">Profit / loss</div>
        <div class = "open-position_wrapper" v-show="fullType">
          <div class = "open-position__wrapper-summary">
            <div class = "open-position__profit-loss__summary">
              <div class = "open-position__profit-loss__summary__sum" 
                :class = "(profitPositions.currency < 0) ? 'color-red' : 'color-green'">{{$moneyf(profitPositions.currency)}} $</div>
              <div class = "open-position__profit-loss__summary__percent"></div>
              <div class = "open-position__profit-loss__summary__point" 
                :class="(profitPositions.points < 0) ? 'color-red' : 'color-green'">{{profitPositions.points.toFixed(2)}} pip</div>
            </div>
          </div>
          <div class = "open-position__wrapper-chart">
            <div class = "open-position_mobile-chart">
              <chart
              :symbol ="pair[0].symbol"
              :stepPoints = "10"></chart>
            </div>
          </div>
        </div>
        <div v-show="fullType" class = "open-position__result">
          <table>   
            <tr class = "open-position__result_row">
              <td class = "open-position__result_row-title">тип</td>
              <td class = "open-position__result_row-title">объем</td>
              <td class = "open-position__result_row-title">сред. цена</td>
              <td class = "open-position__result_row-title">p/l, $</td>
              <td class = "open-position__result_row-title"></td>
            </tr>
            <tr class = "open-position__result_row" v-show = "countPositions.sellCount > 0">
              <td class = "open-position__result_row-data color-red">{{countPositions.sellCount}} Sell</td>
              <td class = "open-position__result_row-data">{{volumePositions.sell.toLocaleString('en')}}</td>
              <td class = "open-position__result_row-data">{{averagePrice.sell.toFixed(5)}}</td>
              <td class = "open-position__result_row-data"
                :class="(profitPositions.currencySell < 0) ? 'color-red' :'color-green'">{{$moneyf(profitPositions.currencySell)}}</td>
              <td class = "open-position__result_row-data-ico" @click = "closeItemSell">
                <i :class= "acordSell ? icoUp : icoDown"></i></td>
            </tr>
            <tr>
              <td colspan = "5">
                <transition enter-active-class = "animated fadeIn">
                    <subtable :pairData = "pair"
                            :sellOrbuy = "-1"
                            v-if = "acordSell">
                    </subtable>
                </transition>
              </td>
            </tr>
            <tr class = "open-position__result_row" v-show = "countPositions.buyCount > 0">
              <td class = "open-position__result_row-data color-green">{{countPositions.buyCount}} Buy</td>
              <td class = "open-position__result_row-data">{{volumePositions.buy.toLocaleString('en')}}</td>
              <td class = "open-position__result_row-data">{{averagePrice.buy.toFixed(5)}}</td>
              <td class = "open-position__result_row-data"
                :class="(profitPositions.currencyBuy <0) ? 'color-red' : 'color-green'">{{profitPositions.currencyBuy.toFixed(2)}}</td>
              <td class = "open-position__result_row-data-ico" @click = "closeItemBuy">
                <i :class = "acordBuy ? icoUp : icoDown"></i></td>
            </tr>
            <tr>
              <td colspan="5">
                <transition enter-active-class="animated fadeIn">
                    <subtable :pairData="pair"
                            :sellOrbuy = "1" 
                            v-if="acordBuy">
                    </subtable>
                </transition>
              </td>
            </tr>
          </table>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import SubTable from "./sig-open-position-widget-subtable";
import SimpleChart from "./sig-simple-chart";
export default {
    components: {
        "subtable":SubTable,
        "chart":SimpleChart
    },
    props: ['pair','full'],
    data() {
        return {
            acordSell: false,
            acordBuy: false,
            icoUp: "icon-icon-down",
            icoDown: "icon-icon-up",
            sum: 0,
            fullType:false
        };
    },
    watch: {
        full: function (val) {
            this.fullType = val
        }
    },
    methods: {
        closeItemSell() {
            this.acordBuy = false;
            this.acordSell = !this.acordSell;
        },
        closeItemBuy() {
            this.acordSell = false;
            this.acordBuy = !this.acordBuy;
        },
        getSum(e)
        {
             this.sum = e;
        },
        showFull() {
            this.fullType = !this.fullType;
        },
    },
    computed: {
        averagePrice() {
            let averagePrice = {
                buy:0,
                sell:0
            }
            let sumPriceSell = 0;
            let sumPriceBuy = 0;
            let cntSell = 0;
            let cntBuy = 0;

            for(let i = 0; i < this.pair.length; i++) {
                if(this.pair[i].side === -1) {
                    sumPriceSell += this.pair[i].priceEnter
                    cntSell++;
                }
                else {
                    sumPriceBuy += this.pair[i].priceEnter
                    cntBuy++;
                }
            }
            averagePrice.sell = sumPriceSell/cntSell;
            averagePrice.buy = sumPriceBuy/cntBuy;

            return averagePrice
        },
        profitPositions() {
            let profit = {
                currency:0,
                points:0,
                currencySell:0,
                pointsSell:0,
                currencyBuy:0,
                pointsBuy:0
            };

            for(let i = 0; i < this.pair.length; i++) {
                profit.currency += this.pair[i].resultDepo
                profit.points += this.pair[i].resultPoint

                if(this.pair[i].side === -1) {
                    profit.currencySell+=this.pair[i].resultDepo
                    profit.pointsSell+=this.pair[i].resultPoint
                }
                else {
                    profit.currencyBuy+=this.pair[i].resultDepo
                    profit.pointsBuy+=this.pair[i].resultPoint
                }
            }
            return profit;
        },

        countPositions() {
            let cnt = {
                sellCount:0,
                buyCount:0
            }; 

            for(let i = 0; i < this.pair.length; i++) {
                if(this.pair[i].side === -1)
                    cnt.sellCount++
                else
                    cnt.buyCount++
            }
            return cnt;
        },

        volumePositions()
        {
            let volume ={
                buy:0,
                sell:0
            }
            for(let i = 0; i < this.pair.length; i++) {
                if(this.pair[i].side === -1)
                    volume.sell+=this.pair[i].volume
                else
                    volume.buy+=this.pair[i].volume
            }
            return volume;
        },
        getPairData() {
            if(this.pair === null) {
                return false
            }
            else {
                return true
            }
        },
        getCount() {
            let cnt = 0;
            if(this.pair === null) {
                cnt = 0;
            } else {
                cnt = this.pair.length
            }
            return cnt;
        },
        getSymbol() {
            let symbol = 0;
            if(this.pair === null) {
                symbol = '';
            } else {
                symbol = this.pair[0].symbol
            }
            return symbol;
        }
    }
};
</script>
<style lang="less" scoped>
table {
  min-width: 100%;
}

.open-position {
  display: flex;
  flex-direction: column;
  background-color: #3d536b;
  //border-radius: 4px;
  position: relative;
  margin-bottom: 8px;
  //margin-top: 8px;
  &-mini {
      margin-bottom: 1px;
      //border-radius: 0px;
      margin-top:0px;
      &:last-child {
          margin-bottom: 12px;
      }
  }

  &__accordion span {
    position: absolute;
    right: 8px;
  }

  &__accordion-wrap {
    background: #374b62;
  }

  &__wrapper {
    position: relative;

    &-summary {
      position: absolute;
      min-width: 100%;
    }

    &-chart {
      max-height: 92px;
      overflow: hidden;
      padding-right: 12px;
      max-width: 360px;
      box-sizing: border-box;
    }
  }

  &__summary {
    display: flex;
    flex-direction: row;
    //justify-content: space-between;
    border-bottom: 1px solid #374b62;
    font-family: Arimo;
    font-size: 13px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 3.08;
    letter-spacing: 0.4px;
    color: #ffffff;
    max-height: 40px;

    &-no-border {
       border-bottom: none; 
    }

    &-ico {
        display: flex;
        align-items: center;
        margin-left: auto;

        i {
            color: #718da8;
            font-size: 16px;
            cursor: pointer;
            margin-right: 8px;
            line-height: 1;
        }
    }

    &-number {
      margin-left: 16px;
      margin-right: 12px;
      min-width: 15px;
    }
    &-currency_pair {
        min-width: 60px;
        margin-right: 12px;
    }
    &-sell-buy {
      color: #ff9292;
      min-width: 60px;
      margin-right: 8px;

      i {
        font-size: 18px;
        line-height: 1;
      }
    }
    &-deposit {
        min-width: 70px;
        margin-right: 8px;
    } 

    &-rait {
      //margin-right: 31px;
    }
  }

  &__profit-loss {
    font-family: Arimo;
    font-size: 10px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 2;
    letter-spacing: 0.4px;
    text-align: left;
    color: #aabed2;
    text-transform: uppercase;
    margin-top: 8px;
    margin-left: 16px;

    &__summary {
      display: flex;
      flex-direction: row;
      font-family: Arimo;
      font-size: 16px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.25;
      letter-spacing: 0.4px;
      color: #0fd7b7;
      padding-bottom: 11px;
      border-bottom: 1px solid #374b62;

      &__sum {
        //font-weight: bold;
        margin-right: 8px;
        margin-left: 16px;
      }

      &__percent {
        margin-right: 8px;
      }
    }
  }

  &__madd-credit {
    display: flex;
    flex-direction: row;

    &-maxdd {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      margin-left: 16px;
      border-right: solid 1px #374b62;

      &-title {
        font-family: Arimo;
        font-size: 10px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 2;
        letter-spacing: 0.4px;
        color: #aabed2;
        text-transform: uppercase;
        margin-top: 8px;
      }

      &-data {
        font-family: Arimo;
        font-size: 16px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.25;
        letter-spacing: 0.4px;
        color: #ff9292;
        margin-bottom: 11px;
      }
    }

    &-credit {
      flex-grow: 2;
      display: flex;
      flex-direction: column;
      margin-left: 16px;

      &-title {
        font-family: Arimo;
        font-size: 10px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 2;
        letter-spacing: 0.4px;
        color: #aabed2;
        text-transform: uppercase;
        margin-top: 8px;
      }

      &-data {
        font-family: Arimo;
        font-size: 16px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.25;
        letter-spacing: 0.4px;
        color: #fff;
        margin-bottom: 11px;
      }
    }
  }

  &__result {
    padding: 0;

    &_row {
      border-top: solid 1px #374b62;
      padding: 0 8px 0 12px;
      outline: none;
      min-width: 360px;

      &:hover {
        background-color: #506b89;
      }

      &:hover span {
        color: #fff;
      }

      &-sub {
        border-top: solid 1px #374b62;
        padding: 0 8px 0 12px;
        min-width: 360px;
      }

      &-title {
        font-family: Arimo;
        font-size: 10px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 4;
        letter-spacing: 0.4px;
        color: #aabed2;
        text-transform: uppercase;
        text-align: right;

        &-sub {
          font-family: Arimo;
          font-size: 10px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: 4;
          letter-spacing: 0.4px;
          color: #aabed2;
          text-transform: uppercase;
          text-align: right;

          &:first-child {
            width: 60px;
            text-align: left;
            padding-left: 12px;
          }

          &:nth-child(2) {
            width: 80px;
            text-align: right;
          }

          &:nth-child(3) {
            width: 88px;
            text-align: right;
          }

          &:nth-child(4) {
            text-align: right;
            width: 88px;
          }

          &:nth-child(5) {
            text-align: right;
            width: 80px;
            padding-right: 8px;
          }
        }

        &:first-child {
          min-width: 60px;
          text-align: left;
          padding-left: 12px;
        }

        &:nth-child(2) {
          min-width: 80px;
          text-align: right;
        }

        &:nth-child(3) {
          min-width: 88px;
          text-align: right;
        }

        &:nth-child(4) {
          text-align: right;
          min-width: 88px;
        }
      }

      &-data {
        font-family: Arimo;
        font-size: 13px;
        //font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 2.15;
        letter-spacing: 0.4px;
        text-align: left;
        color: #ffffff;

        &-sub {
          font-family: Arimo;
          font-size: 13px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: 2.15;
          letter-spacing: 0.4px;
          text-align: right;
          color: #ffffff;

          &:first-child {
            width: 60px;
            text-align: left;
            padding-left: 8px;
          }

          &:nth-child(2) {
            width: 68px;
            text-align: right;
            padding-right: 12px;
          }

          &:nth-child(3) {
            width: 67px;
            text-align: right;
            padding-right: 21px;
          }

          &:nth-child(4) {
            text-align: right;
            width: 31px;
            padding-right: 14px;
          }

          &:nth-child(5) {
            text-align: right;
            width: 31px;
            padding-right: 12px;
          }

          &-ico {
            color: #718da8;
            width: 24px;
            text-align: right;
            padding: 4px;
          }
        }

        &:nth-child(1) {
          width: 60px;
          text-align: left;
          padding-left: 12px;
        }

        &:nth-child(2) {
          text-align: right;
        }

        &:nth-child(3) {
          text-align: right;
        }

        &:nth-child(4) {
          text-align: right;
        }

        &:nth-child(5) {
          text-align: right;
          width: 76px;
          padding-right: 12px;
        }

        &-ico {
          color: #718da8;
          font-size: 16px;
          text-align: center;
          padding-top: 3px;
          width: 34px;
          display: block;
          cursor: pointer;

          &-sub {
            color: #718da8;
            font-size: 18x;
            width: 24px;
            display: block;
            text-align: center;
            padding-top: 3px;

            &:hover {
              color: #fff;
            }
          }
        }
      }
    }
  }
}
</style>